import React, { FC } from 'react'
import RadioButton from '@components/std-components/Radio'
import * as css from './styles.css'
import { useTranslation } from 'react-i18next'

export const radioOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
]

const NotificationConfirmation: (product, selected, onSelect) => FC =
  (product, selected, onSelect) => () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation()
    return (
      <div>
        <p>
          {`(${product.name} - ${product.sku}) will be cancelled.`}
          <br />
          {t(
            'productDetails.cancelProductPopup.confirmationMessage',
            'Do you want users to receive a notification?'
          )}
        </p>
        <div className={css.radioBtnWrapper}>
          {radioOptions.map(option => (
            <RadioButton
              label={t(`bb.common.label.${option.label}`, option.label)}
              checked={selected === option.value}
              id={`${option.label}`}
              key={`${option.label}`}
              name={`${option.label}`}
              onRadioButtonClick={() => onSelect(option.value)}
            />
          ))}
        </div>
      </div>
    )
  }

export default NotificationConfirmation
